"use client";

import { TarotCard, SUIT_SYMBOLS, romanNumeral } from "./types";

interface TarotCardFaceProps {
  card: TarotCard;
  showPosition?: boolean;
}

export function TarotCardFace({ card, showPosition }: TarotCardFaceProps) {
  const isReversed = card.orientation === "reversed";

  return (
    <div
      className="w-[200px] sm:w-[220px] rounded-xl overflow-hidden mx-auto animate-slide-up bg-ish-bg-card border-2 border-ish-border shadow-[0_4px_20px_rgba(0,0,0,0.08)]"
    >
      {/* Position label */}
      {showPosition && card.position && (
        <div
          className="text-center py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] bg-ish-accent-light text-ish-accent"
        >
          {card.position}
        </div>
      )}

      {/* Card illustration area */}
      <div
        className={`h-[160px] sm:h-[180px] flex items-center justify-center relative ${
          isReversed
            ? "bg-linear-to-b from-[#f5e6df] to-[#faf9f7]"
            : "bg-linear-to-b from-[#faf9f7] to-[#f5e6df]"
        }`}
      >
        <div className={`text-center ${isReversed ? "rotate-180" : ""}`}>
          <p className="text-4xl mb-1">
            {card.suit ? SUIT_SYMBOLS[card.suit] || "✦" : "✦"}
          </p>
          <p
            className="text-[40px] font-bold font-serif text-ish-dark"
          >
            {card.arcana === "major" ? romanNumeral(card.id) : card.name_en.split(" ")[0]}
          </p>
        </div>
        {/* Orientation badge */}
        <div
          className={`absolute bottom-2 right-2 text-[9px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${
            isReversed
              ? "bg-[rgba(180,80,60,0.1)] text-[#b4503c]"
              : "bg-[rgba(80,160,80,0.1)] text-[#50a050]"
          }`}
        >
          {isReversed ? "Reversed" : "Upright"}
        </div>
      </div>

      {/* Card info */}
      <div className="p-4">
        <h3
          className="text-[16px] font-bold leading-tight font-serif text-ish-dark"
        >
          {card.name_en}
        </h3>
        <p className="text-[13px] mt-0.5 text-ish-text-muted">
          {card.name_hi} · {card.vedic_name}
        </p>
      </div>
    </div>
  );
}
